import { SliceCaseReducers, createSlice } from '@reduxjs/toolkit';

export interface ArticleState {
  showArticleModal: boolean;
}

export const slice = createSlice<ArticleState, SliceCaseReducers<ArticleState>>({
  name: 'article',
  initialState: {
    showArticleModal: false,
  },
  reducers: {
    setShowArticleModal: (state, action: { payload: boolean }) => ({
      ...state,
      showArticleModal: action.payload,
    }),
  },
});

export const { setShowArticleModal } = slice.actions;

export const showArticleModalSelector = (state: { article: ArticleState }) =>
  state.article.showArticleModal;

export default slice.reducer;
